import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import * as R from 'ramda'

import Select from '@Form/Select'
import Input from '@Form/Input'
import CheckboxGroup from '@Form/CheckboxGroup'
import RadioGroup from '@Form/RadioGroup'
import Button from '@UniformComponents/Button'
import Panel from '@UniformComponents/Panel'

import Variable from './Variable'
import Variable2 from './model/Variable'
import Test from './components/Test'
import Settings from './components/Settings'

import Formula from './components/Formula'

import Dependency from './model/Dependency'
import BubbleLoader from '../../../UniformComponents/BubbleLoader'

const divider = () => (
    <div
        style={{
            background: '#dce4f3',
            height: '1px',
        }}
    />
)

@observer
class CreateEdit extends Component {
    dependencyQuestions = []

    variables = []

    @observable questions = []

    constructor(props) {
        super(props)

        const { store } = props
        const kpiId = parseInt(props.kpiId, 10)

        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'kpi',
                url: '/intranet/kpicreator',
                title: 'Kpis',
            },
            {
                name: 'kpiId',
                url: `/intranet/kpicreator/${kpiId}`,
                title: String(kpiId),
            },
        ]

        this.state = {
            stage: 1,
            clients: [],
            industries: [],
            surveyTypes: [],
            productTypes: [],
            respondentTypes: [],
            response: {},
            typeToIndustry: {},
            ready: false,
        }
    }

    async componentDidMount() {
        const { kpiStore, kpiId } = this.props
        const [kpi, clients, prodMap] = await Promise.all(
            [
                kpiStore.get(parseInt(kpiId, 10)),
                kpiStore.getClients(),
                this.getProdMap(),
                this.getClientSpecificTypes(1),
            ],
        )

        this.kpi = kpi

        if (this.kpi.kpiId !== 0) {
            await kpiStore.getQList(this.kpi)
            await kpiStore.getKpis(this.kpi)
        }

        if (this.kpi.dependencies.length > 0) {
            const dependencyIds = this.kpi.dependencies.reduce((set, { id }) => (
                set.add(id.toUpperCase())
            ), new Set())
            const kpiDependencies = kpiStore.kpiDependencies
                .filter(({ value }) => dependencyIds.has(value))
                .map(({ value, label }) => ({
                    value,
                    label,
                    isKpi: true,
                }))
            kpiStore.dependencyQuestions = kpiStore.qlistQuestions
                .filter(({ value }) => dependencyIds.has(value))
                .map(({ question, value, label, formId }) => ({
                    value,
                    label,
                    formId,
                    question,
                })).concat(kpiDependencies)
        }

        this.setState({
            clients,
            industries: Object.values(prodMap.industries),
            surveyTypes: Object.values(prodMap.surveyTypes),
            respondentTypes: Object.values(prodMap.respondentTypes),
            productTypes: Object.values(prodMap.productTypes),
            typeToIndustry: prodMap.typeToIndustry,
            ready: true,
            stage: this.kpi.kpiId !== 0
                ? 10
                : 0,
        })
    }

    getProdMap = async () => {
        const { store } = this.props
        const productMaps = await store.http.get('/productmap')

        const prodMap = {
            typeToIndustry: {},
            industries: {},
            surveyTypes: {},
            respondentTypes: {},
            productTypes: {},
        }

        productMaps.forEach((map) => {
            if (!prodMap.typeToIndustry[map.industrycode]) {
                prodMap.typeToIndustry[map.industrycode] = {}
            }

            if (!prodMap.typeToIndustry[map.industrycode][map.producttypecode]) {
                prodMap.typeToIndustry[map.industrycode][map.producttypecode] = []
            }

            if (!prodMap.typeToIndustry[map.industrycode][map.producttypecode]
                .includes(map.surveytypecode)) {
                prodMap.typeToIndustry[map.industrycode][map.producttypecode]
                    .push(map.surveytypecode)
            }

            if (!prodMap.industries[map.industrycode]) {
                prodMap.industries[map.industrycode] = {
                    label: map.industryname,
                    value: map.industrycode,
                }
            }

            if (!prodMap.surveyTypes[map.surveytypecode]) {
                prodMap.surveyTypes[map.surveytypecode] = {
                    label: map.surveytypename,
                    value: map.surveytypecode,
                }
            }

            if (!prodMap.respondentTypes[map.respondenttypecode]) {
                prodMap.respondentTypes[map.respondenttypecode] = {
                    label: map.respondenttypename,
                    value: map.respondenttypecode,
                    industry: map.industrycode,
                    surveyTypes: new Set([map.surveytypecode]),
                }
            } else {
                prodMap.respondentTypes[map.respondenttypecode].surveyTypes.add(map.surveytypecode)
            }

            if (!prodMap.productTypes[map.producttypecode]) {
                prodMap.productTypes[map.producttypecode] = {
                    label: map.producttypename.replace(`${map.industryname} - `, ''),
                    value: map.producttypecode,
                }
            }
        })

        return prodMap
    }

    getFilteredSurveyTypes = () => {
        const {
            surveyTypes, typeToIndustry, clientSpecificTypes,
        } = this.state

        const allowedTypes = []

        if (!this.kpi.productType || !this.kpi.industry) return []
        const { productType } = this.kpi

        if (typeToIndustry[this.kpi.industry][productType]) {
            if (!this.kpi.clientId) {
                allowedTypes.push(...typeToIndustry[this.kpi.industry][productType])
            } else {
                allowedTypes.push(...typeToIndustry[this.kpi.industry][productType]
                    .filter((s) => clientSpecificTypes.surveyTypes.includes(s)))
            }
        }
        return surveyTypes
            .filter((st) => allowedTypes.includes(st.value))
    }

    addVariable = () => {
        const { variables } = this.kpi
        const responseClone = variables.slice()
        responseClone.push(new Variable2({}))

        this.kpi.variables = responseClone
    }

    addDependency = () => {
        const responseClone = R.clone(this.kpi.dependencies.slice())
        responseClone.push(new Dependency({
            id: '',
            dependencyType: 'question',
        }))
        this.dependencyQuestions.push({
            value: '',
            label: 'NOT DEFINED',
        })
        this.kpi.dependencies = responseClone
        console.log(this.kpi.dependencies)
    }

    removeDependency = (index) => {
        const dependenciesClone = this.kpi.dependencies.slice()
        dependenciesClone.splice(index, 1)
        this.dependencyQuestions.splice(index, 1)
        this.kpi.dependencies = dependenciesClone
    }

    changeDepenencyType = (field, index) => {
        const { kpiStore } = this.props
        const responseClone = R.clone(this.kpi.dependencies.slice())
        const dependencyQuestions = R.clone(kpiStore.dependencyQuestions.slice())

        responseClone[index].dependencyType = field.value
        dependencyQuestions[index] = {
            value: field.value,
            label: field.label,
            isKpi: true,
        }
        kpiStore.dependencyQuestions = dependencyQuestions
        this.kpi.dependencies = responseClone
    }

    changeDepenency = async (field, index) => {
        const { kpiStore } = this.props
        const responseClone = R.clone(this.kpi.dependencies.slice())
        const dependencyQuestions = R.clone(kpiStore.dependencyQuestions.slice())

        responseClone[index].id = field.value
        dependencyQuestions[index] = {
            value: field.value,
            label: field.label,
            question: field.question,

            isKpi: (responseClone[index].dependencyType === 'kpi'),
        }
        kpiStore.dependencyQuestions = dependencyQuestions
        console.log('changeDepenency', responseClone)
        this.kpi.dependencies = responseClone
    }

    getFilteredProductTypes = () => {
        const { productTypes, typeToIndustry } = this.state

        if (!this.kpi.industry) return []

        const allowedTypes = Object.keys(typeToIndustry[this.kpi.industry])

        return productTypes.filter((pt) => allowedTypes.includes(pt.value))
    }

    getFilteredResponentTypes = () => {
        const { respondentTypes } = this.state

        if (!this.kpi.surveyType || !this.kpi.industry) return []

        return respondentTypes.filter((rt) => rt.industry === this.kpi.industry
                    && [...rt.surveyTypes].some((st) => this.kpi.surveyType === st))
    }

    getQList = async (respondentType) => {
        const { kpiStore } = this.props
        const { kpi } = this
        const { productType, surveyType } = kpi
        console.log('getQList', productType, surveyType, respondentType)
        if (
            !productType
            || !surveyType
            || !respondentType
        ) return

        this.questions = await kpiStore.getQList(Object.assign(kpi, { respondentType }))
    }

    onchange = async (field, promise, fieldResets) => {
        const { kpi } = this
        const { response, stage } = this.state
        const responseClone = R.clone(response)

        if (fieldResets) fieldResets(responseClone, field.value)

        if (promise) await promise(field.value)

        kpi[field.name] = field.value

        this.setState({
            stage: stage + (Object.prototype.hasOwnProperty.call(kpi, field.name) ? 0 : 1),
        })
    }

    getClientSpecificTypes = async (clientId) => {
        const { store } = this.props
        if (!clientId) return
        const [industries, surveyTypes] = await Promise.all([
            store.http.get(`/client/${clientId}/industry`),
            store.http.get(`/client/${clientId}/surveytype`),
        ])

        this.setState({
            clientSpecificTypes: {
                surveyTypes,
                industries: industries.map((i) => i.code),
            },
        })
    }

    getDependencyOptions = (type) => {
        const { kpiStore } = this.props
        const { qlistQuestions, kpiDependencies } = kpiStore
        return (type === 'question')
            ? qlistQuestions
            : kpiDependencies
    }

    stages = () => {
        const { kpiStore } = this.props
        const { clients, industries } = this.state
        const { kpi } = this

        return [
            {
                type: 'select',
                title: 'Which client should this appear for?',
                options: clients,
                name: 'clientId',
                notmandatory: true,
                promise: this.getClientSpecificTypes,
                fieldResets: () => {
                    kpi.surveyType = ''
                    kpi.industry = ''

                    kpi.dependencies = []
                    kpi.variables = []
                },
            },
            {
                type: 'select',
                title: 'What industry is this for?',
                options: industries,
                name: 'industry',
                fieldResets: () => {
                    kpi.surveyType = ''
                    kpi.respondentType = ''
                    kpi.productType = ''

                    kpi.dependencies = []
                    kpi.variables = []
                },
            },
            {
                type: 'radioGroup',
                title: 'What product type should this appear for?',
                options: this.getFilteredProductTypes(),
                name: 'productType',
                key: `${this.kpi.industry}_productType`,
                fieldResets: () => {
                    kpi.surveyType = ''
                    kpi.respondentType = ''
                    kpi.dependencies = []
                    kpi.variables = []
                },
            },
            {
                type: 'radioGroup',
                title: 'What type of survey should this appear on?',
                options: this.getFilteredSurveyTypes(),
                name: 'surveyType',
                key: `${this.kpi.productType}_surveyType`,
                fieldResets: () => {
                    kpi.respondentType = ''
                    kpi.dependencies = []
                    kpi.variables = []
                },
            },
            {
                type: 'radioGroup',
                title: 'What product type should this appear for?',
                options: this.getFilteredResponentTypes(),
                name: 'respondentType',
                key: `${this.kpi.surveyType}_respondentType`,
                promise: this.getQList,
                fieldResets: () => {
                    kpi.dependencies = []
                    kpi.variables = []
                },
            },
            {
                type: 'radioGroup',
                title: 'Is this formula...',
                options: [
                    {
                        value: false,
                        label: 'Run from KPI Creator',
                    },
                    {
                        value: true,
                        label: 'Back-end coded',
                    },
                ],
                name: 'isHardcoded',
                key: 'isHardcoded',
                fieldResets: (_, value) => {
                    if (value) {
                        this.kpi.formula = []
                    } else {
                        kpiStore.addOption(this.kpi)
                    }
                },
            },
            {
                type: 'dependencies',
                title: 'Dependencies',
                name: 'dependencies',
                types: [
                    {
                        value: 'question',
                        label: 'Question',
                    },
                    {
                        value: 'kpi',
                        label: 'Kpi',
                    },
                ],
                options: kpiStore.qlistQuestions,
            },
            {
                type: 'input',
                title: 'Min Qlist Questions',
                name: 'minQlistQuestions',
            },
            {
                type: 'settings',
                title: 'Settings',
                name: 'settings',
            },
            {
                type: 'variables',
                title: 'Variables',
                name: 'variables',
            },
        ]
    }

    changeVariable = (field, index) => {
        console.log('changeVariable', field, index)
        const { variables } = this.kpi
        const responseClone = R.clone(variables.slice())

        responseClone[index][field.name] = field.value
        this.kpi.variables = responseClone
    }

    registerVariable = (f) => {
        this.variables.push(f)
    }

    renderStages = () => {
        const { kpiStore } = this.props
        const { kpi } = this
        const { stage, response } = this.state
        const stages = R.slice(0, stage, this.stages().filter((s) => !s.hide))

        return stages.map((s) => {
            switch (s.type) {
                case 'input':
                    return (
                        <Input
                            onBlur={(field) => this.onchange(field, s.promise, s.fieldResets)}
                            placeholder="Min QList Questions"
                            defaultValue={kpi[s.name]}
                            name={s.name}
                            label={s.title}
                            register={this.register}
                            unregister={this.unregister}
                            isMandatory={!s.notmandatory}
                            key={s.name}
                        />
                    )
                case 'select':
                    return (
                        <div key={s.name}>
                            {/* <div className="subHeading">{s.title}</div> */}
                            <Select
                                options={s.options}
                                label={s.title}
                                onBlur={(field) => this.onchange(field, s.promise, s.fieldResets)}
                                name={s.name}
                                value={s.options.find((o) => o.value === kpi[s.name]) || ''}
                                isMandatory={!s.notmandatory}
                                register={this.register}
                                unregister={this.unregister}
                            />
                        </div>
                    )
                case 'multiCheckbox':
                    return (
                        <div>
                            {/* <div className="subHeading">{s.title}</div> */}
                            <CheckboxGroup
                                label={s.title}
                                options={s.options || []}
                                onBlur={(field) => this.onchange(field, s.promise, s.fieldResets)}
                                name={s.name}
                                defaultChecked={response[s.name] || []}
                                returnValueUnchanged
                                isMandatory
                                refreshOnRender
                                register={this.register}
                                unregister={this.unregister}
                                key={s.name}
                            />
                        </div>
                    )
                case 'radioGroup':
                    return (
                        <div>
                            <div className="subHeading">{s.title}</div>
                            <RadioGroup
                                label={s.title}
                                options={s.options || []}
                                onBlur={(field) => this.onchange(field, s.promise, s.fieldResets)}
                                name={s.name}
                                defaultChecked={this.kpi[s.name]}
                                returnValueUnchanged
                                isMandatory
                                refreshOnRender
                                register={this.register}
                                unregister={this.unregister}
                                key={s.key}
                            />
                        </div>
                    )
                case 'settings':
                    return <Settings store={kpiStore} kpi={this.kpi} />
                case 'dependencies':
                    return (
                        <Fragment>
                            {divider()}
                            <h4>{s.title}</h4>
                            <div id="dependencies">
                                {kpi.dependencies.map(({ id, dependencyType }, index) => (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <Fragment>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flex: 1,
                                                    gap: '10px',
                                                }}
                                            >
                                                <Select
                                                    key={`dependency_${id}`}
                                                    options={this.getDependencyOptions(dependencyType)}
                                                    onBlur={
                                                        (f) => this.changeDepenency(f, index)
                                                    }
                                                    name={s.name}
                                                    value={this.getDependencyOptions(dependencyType).find((o) => o.value === id) || ''}
                                                    isMandatory={!s.notmandatory}
                                                    register={this.register}
                                                    unregister={this.unregister}
                                                />
                                                <Select
                                                    key={`dependency_type_${id}`}
                                                    options={s.types}
                                                    onBlur={
                                                        (f) => this.changeDepenencyType(f, index)
                                                    }
                                                    name={s.name}
                                                    value={s.types.find((o) => o.value === dependencyType) || ''}
                                                    isMandatory={!s.notmandatory}
                                                    register={this.register}
                                                    unregister={this.unregister}
                                                />
                                            </div>
                                            <i
                                                className="fal fa-trash-alt fa-2x"
                                                style={{ marginLeft: '10px', cursor: 'pointer' }}
                                                onClick={() => this.removeDependency(index)}
                                            />
                                        </Fragment>
                                    </div>
                                ))}
                                <Button
                                    label="Add Dependency"
                                    onClick={this.addDependency}
                                    cssClass="regular secondary"
                                />
                            </div>
                        </Fragment>
                    )
                case 'variables':
                    return (
                        <Fragment key={s.name}>
                            {divider()}
                            <h4>{s.title}</h4>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '10px',
                                }}
                            >
                                {kpi.variables.map((v) => (
                                    <Variable
                                        key={v.id}
                                        variable={v}
                                        register={this.registerVariable}
                                        questions={kpiStore.dependencyQuestions}
                                        onDelete={() => kpiStore.removeVariable(kpi, v.id)}
                                    />
                                ))}
                            </div>
                            <Button
                                label="Add Variable"
                                onClick={this.addVariable}
                                cssClass="regular secondary"
                            />
                        </Fragment>
                    )
                case 'options':
                    return (
                        <div>
                            <div className="subHeading">{s.title}</div>
                            <div className="dropdownOptions">
                                {response.options && response.options.map((o, index) => (
                                    <div className="dropdownOption">
                                        <Input
                                            name="option"
                                            onBlur={(field) => this.changeOptions(field, index)}
                                            defaultValue={o.en_GB}
                                            placeholder="Please enter a dropdown option ..."
                                            key={`option${o.id}${o.en_GB}`}
                                        />
                                        <Button
                                            key={`delete${o.id}${o.en_GB}`}
                                            icon="far fa-trash-alt fa-2x"
                                            onClick={() => this.removeOption(index)}
                                            classClass="regular error"
                                        />
                                    </div>
                                ))}
                                <Button cssClass="regular secondary" onClick={this.addNewOption}>Add New Option</Button>
                            </div>
                        </div>
                    )
                default:
                    return <div />
            }
        })
    }

    save = async () => {
        const { kpiStore, store, history } = this.props
        const { kpi } = this

        try {
            await kpiStore.save(kpi)
            store.addNotification(null, 'Kpi saved', 'success')
            history.push('/intranet/kpicreator')
        } catch (e) {
            console.log(e)
            store.addNotification(null, 'Error saving kpi', 'error')
        }
    }

    render() {
        const { kpiStore } = this.props
        const { ready } = this.state
        const { kpi } = this
        return (
            <Fragment>
                <Test store={kpiStore} kpi={kpi}/>
                {!ready && <BubbleLoader />}
                {ready && (
                    <Panel>
                        <Input
                            label="Please enter a id for this KPI"
                            name="kpiId"
                            onBlur={this.onchange}
                            isMandatory
                            register={this.register}
                            unregister={this.unregister}
                            defaultValue={kpi.kpiId}
                        />
                        <Input
                            label="Please enter a name for this KPI"
                            name="name"
                            onBlur={this.onchange}
                            isMandatory
                            register={this.register}
                            unregister={this.unregister}
                            defaultValue={kpi.name}
                        />
                        <Input
                            label="Please describe this KPI and its use"
                            name="description"
                            onBlur={this.onchange}
                            isMandatory
                            register={this.register}
                            unregister={this.unregister}
                            defaultValue={kpi.description}
                        />
                        {this.renderStages()}
                        {!kpi.isHardcoded && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '10px',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '10px',
                                    }}
                                >
                                    {kpi.formula.map(({ name, formula, id }) => (
                                        <Formula
                                            key={id}
                                            name={name}
                                            formula={formula}
                                            id={id}
                                            onChange={(obj) => kpiStore.changeFormula(kpi, obj)}
                                            onDelete={() => kpiStore.removeOption(kpi, id)}
                                        />
                                    ))}
                                </div>
                                <Button
                                    label="Add option"
                                    cssClass="regular secondary"
                                    onClick={() => kpiStore.addOption(kpi)}
                                />
                            </div>
                        )}
                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                            <Button
                                label="Test"
                                onClick={kpiStore.toggleTest}
                                cssClass="regular secondary"
                            />
                            <Button
                                label="Save"
                                onClick={this.save}
                                cssClass="regular primary"
                            />
                        </div>
                    </Panel>
                )}
            </Fragment>
        )
    }
}

export default CreateEdit
